import Model from "../classes/Model";
import ValidationError from "../classes/ValidationError";
import Api from "../classes/api/Visit";
import Client from "./Client";
import Subscription from "./Subscription";
import Trainer from "./Trainer";
import Direction from "./Direction";
import User from "./User";
import ClientSubscription from "./ClientSubscription";

export default class Visit extends Model {

    get id() {
        return this._id;
    }

    set companyId(value) {
        this._companyId = value;
    }
    get companyId() {
        return this._companyId;
    }

    set filiationId(value) {
        this._filiationId = value;
    }
    get filiationId() {
        return this._filiationId;
    }

    set scheduleId(value) {
        this._scheduleId = value;
    }
    get scheduleId() {
        return this._scheduleId;
    }

    set groupId(value) {
        this._groupId = value;
    }
    get groupId() {
        return this._groupId;
    }

    set roomId(value) {
        this._roomId = value;
    }
    get roomId() {
        return this._roomId;
    }

    set clientId(value) {
        this._clientId = value;
    }
    get clientId() {
        return this._clientId;
    }

    set directionId(value) {
        this._directionId = value;
    }
    get directionId() {
        return this._directionId;
    }

    set trainerId(value) {
        this._trainerId = value;
    }
    get trainerId() {
        return this._trainerId;
    }

    set subscriptionId(value) {
        this._subscriptionId = value;
    }
    get subscriptionId() {
        return this._subscriptionId;
    }

    set subscriptionClientId(value) {
        this._subscriptionClientId = value;
    }
    get subscriptionClientId() {
        return this._subscriptionClientId;
    }
    set isReservation(value) {
        this._isReservation = value;
    }
    get isReservation() {
        return this._isReservation;
    }
    set date(value) {
        this._date = value;
    }
    get date() {
        return this._date;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get client() {
        return this._client;
    }
    set client(value) {
        this._client = value;
    }

    set subscription(value) {
        this._subscription = value;
    }
    get subscription() {
        return this._subscription;
    }
    set subscriptionClient(value) {
        this._subscriptionClient = value;
    }
    get subscriptionClient() {
        return this._subscriptionClient;
    }
    set trainer(value) {
        this._trainer = value;
    }
    get trainer() {
        return this._trainer;
    }
    set schedule(value) {
        this._schedule = value;
    }
    get schedule() {
        return this._schedule;
    }
    set direction(value) {
        this._direction = value;
    }
    get direction() {
        return this._direction;
    }
    set creator(value) {
        this._creator = value;
    }
    get creator() {
        return this._creator;
    }


    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
        return {
        };
    }

    static toResponse(data) {
        let client = null;
        if (undefined !== data.client && data.client) {
            client = new Client(Client.toResponse(data.client));
        }
        let subscription = null;
        if (undefined !== data.subscription && data.subscription) {
            subscription = new Subscription(Subscription.toResponse(data.subscription));
        }
        let subscriptionClient = null;
        if (undefined !== data.subscriptionClient && data.subscriptionClient) {
            subscriptionClient = new ClientSubscription(ClientSubscription.toResponse(data.subscriptionClient));
        }
        let trainer = null;
        if (undefined !== data.trainer && data.trainer) {
            trainer = new Trainer(Trainer.toResponse(data.trainer));
        }
        let direction = null;
        if (undefined !== data.direction && data.direction) {
            direction = new Direction(Direction.toResponse(data.direction));
        }
        let creator = null;
        if (undefined !== data.creator && data.creator) {
            creator = new User(User.toResponse(data.creator));
        }
        let schedule = null;
        if (undefined !== data.schedule && data.schedule) { //Костыль
            schedule = data.schedule;
        }
        return {
            id: data.id,
            companyId: data.company_id,
            filiationId: data.filiation_id,
            scheduleId: data.schedule_id,
            groupId: data.group_id,
            roomId: data.room_id,
            clientId: data.client_id,
            directionId: data.direction_id,
            trainerId: data.trainer_id,
            subscriptionId: data.subscription_id,
            subscriptionClientId: data.subscription_client_id,
            isReservation: data.is_reservation,
            date: data.date,
            createdAt: data.created_at,
            createdBy: data.created_by,
            client: client,
            subscription: subscription,
            subscriptionClient: subscriptionClient,
            trainer: trainer,
            schedule: schedule,
            direction: direction,
            creator: creator,
        };
    }

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = [], parameters = {}) {
        return Api.getList(page, perPage, sort, extraFields, parameters).then((response) => {
            let data = [];
            for (let visit of response.data) {
                data.push(new this(this.toResponse(visit)));
            }
            return {data, headers: response.headers};
        });
    }

    static getListBySchedule(scheduleId) {
        return Api.getBySchedule(scheduleId).then((response) => {
            let data = [];
            for (let visit of response.data) {
                data.push(new this(this.toResponse(visit)));
            }
            return data;
        });
    }

    static get(id) {
        return Api.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }

    static getMyReservation(id) {
        return Api.getMyVisitReservation(id).then((response) => {
            console.log('response');
            console.log(response)
            let data = [];
            for (let visit of response.data.reservation) {
                data.push(new this(this.toResponse(visit)));
            }
            return data;
        });

            // .then(({response}) => {
            // console.log('response');
            // console.log(response);
            // let data = [];
            // for (let visit of response) {
            //     data.push(new this(this.toResponse(visit)));
            // }
            // return {data, headers: response.headers};
        // });
    }


    static add(scheduleId, clientId, clientSubscriptionId) {
        return Api.add(scheduleId, clientId, clientSubscriptionId).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
        });
    }

    static addReservation(scheduleId, clientId, clientSubscriptionId) {
        return Api.addReservation(scheduleId, clientId, clientSubscriptionId).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return Api.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    remove() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return Api.remove(this.id).then(({data}) => {
            return data.success;
        });
    }

}
